export enum eValidationStatus {
  Create = 1,
  Started = 2,
  Finished = 3,
}
